import { render, staticRenderFns } from "./ProjectSocialPlatformGoogleMyBusiness.vue?vue&type=template&id=75ab34fe"
import script from "./ProjectSocialPlatformGoogleMyBusiness.vue?vue&type=script&lang=ts"
export * from "./ProjectSocialPlatformGoogleMyBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports